import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  static values = {
    url: String,
    idAttribute: { type: String, default: "goalId" }
  }

  connect() {
    this.sortable = Sortable.create(this.element, {
      handle: "[data-sort-handle]",
      animation: 150,
      onEnd: this.onEnd.bind(this)
    })
  }

  disconnect() {
    this.sortable.destroy()
  }

  onEnd() {
    const order = Array.from(this.element.children).map(el => el.dataset[this.idAttributeValue])

    fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content
      },
      body: JSON.stringify({ order })
    })
      .then(response => {
        if (!response.ok) this.#showError("Reorder failed — please try again.")
      })
      .catch(() => this.#showError("Reorder failed — please check your connection."))
  }

  #showError(message) {
    const flash = document.getElementById("flash")
    if (!flash) return

    const alert = document.createElement("div")
    alert.className = "alert alert-error shadow-lg"
    alert.setAttribute("role", "alert")
    alert.setAttribute("data-controller", "flash")
    alert.setAttribute("data-action", "click->flash#dismiss")
    alert.innerHTML = `<span>${message}</span>`
    flash.appendChild(alert)
  }
}
